export enum MapIconEnum {
    Project = 'map-marker-blue.png',
    SelectedProject = 'map-marker-black.png',
    ExternalTurbine = 'turbine-external-map-marker-red.png',
    SelectedExternalTurbine = 'turbine-map-marker-selected.png',
    NewTurbine = 'turbine-map-marker-blue.png',
    SelectedNewTurbine = 'turbine-map-marker-selected.png',
    MetStation = 'metmast.png',
    SelectedMetStation = 'metmast-selected.png',
    EmptyProject = 'empty-project.png',
    Placemark = 'pin.png',
    ProjectCenter = 'map-marker-black.png',
}
export enum AdvancedFilterTypeEnum {
    Number = 'Number',
    Date = 'Date',
    Text = 'Text',
}
export enum AdvancedFilterOperatorEnum {
    Equals = 'Equal',
    DoesNotEqual = 'DoesNotEqual',
    GreaterThanOrEqual = 'GreaterThanOrEqual',
    LessThanOrEqual = 'LessThanOrEqual',
    Contains = 'Contains',
    StartsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    GreaterThan = 'Greater',
    LessThan = 'Less',
}
export enum UserRolesEnum {
    ApplicationAccess = 'ApplicationAccess',
}
export enum UserNotificationSeverityEnum {
    Info,
    Warning,
    Error,
}
export enum UnitEnum {
    Degrees = 'degrees',
    DegreesCentigrade = 'degreescentigrade',
    GWh = 'gwh',
    GWhPerYear = 'gwhperyear',
    KWh = 'kwh',
    KWhPerYear = 'kwhperyear',
    KilogramsPerCubicMeters = 'kilogramspercubicmeters',
    LatLong = 'latlong',
    MW = 'mw',
    MWhPerYear = 'mwhperyear',
    Meters = 'meters',
    MetersPerSecond = 'meterspersecond',
    NoUnit = 'nounit',
    Percentage = 'percentage',
    RotorDiameter = 'rotordiameter',
}
export enum ProjectTypeEnum {
    Sales = 'Sales',
    Certification = 'Certification',
    Benchmark = 'Benchmark',
    Test = 'Test',
    LegacySales = 'LegacySales',
    Development = 'Development',
}
export enum NearbyProjectTypeFilterEnum {
    All,
    SalesOnly,
    None,
}
export enum LoadsThresholdFilterEnum {
    ShowAll = 0,
    HideBelowAlarm = 1,
    HideBelowWarning = 2,
    HideAboveDesignLifeTime = 3
}
export enum SensorGroupEnum {
    FatigueNonServicable = 'Fatigue (Non-Servicable)',
    FatigueServicable = 'Fatigue (Servicable)',
    Extreme = 'Extreme',
}
export enum FileTypeEnum {
    PDF = 'Pdf',
    ZIP = 'Zip',
}
export enum ReportLanguageEnum {
    English = "English",
    German = "German",
}
export enum WorkflowType {
    Baseline = 'Baseline',
    CFD = 'CFD',
    CFDL2 = 'CFD L2',
    Wasp = 'WAsP',
    PadWise = 'Pad-wise'
}
export enum EffectiveTurbulenceModeEnum {
    IecQuantile = 2,
    LogNormalQuantile = 3,
}
export enum WakeTurbulenceModelEnum {
    SteenFrandsen = 0,
    TNO = 2,
}
export enum TidOptionsEnum {
    MastDataScaling = 1,
    MastDataCfdScaling = 2,
    CalculatedFromIec = 3,
    Customer = 4,
    CustomerTimeSeries = 5,
    WakeGuard = 6,
    Wake2e = 7
}
export enum WsdOptionsEnum {
    Wasp = 1,
    Cfd = 2,
    Customer = 3,
    CustomerTimeSeries = 4,
}
export enum MapLayerType {
    OpenStreetMap = 'openstreetmap',
    MapTilerBasic = 'maptilerbasic',
    MapTilerBright = 'maptilerbright',
    MapTilerOcean = 'maptilerocean',
    MapTilerOpenStreetMap = 'maptileropenstreetmap',
    MapTilerOutdoor = 'maptileroutdoor',
    MapTilerSatellite = 'maptilersatellite',
    MapTilerTopo = 'maptilertopo',
}
export enum WindRoseContentEnum {
    AverageWindSpeed,
    Frequency,
    Energy,
    Inflow,
    TurbulenceIntensity,
    WeibullA,
    WeibullK,
    WindShear,
}
export enum MesoscaleDescriptionEnum {
    None = 1,
    Vcl2 = 2,
    Vcl3 = 3,
}
export enum ExternalClimateTypeEnum {
    NewTimeseries = 1,
    ReuseTimeseries = 2,
    NewAmbient = 3,
    ReuseAmbient = 4,
    PadWise = 5
}
export enum MapParentView {
    LayoutsList,
    ManageLayout,
    LoadModels,
    DirectionalSettings,
    ExternalTurbines,
    MetStations,
    Climate,
    OneMap,
}
export enum LayoutMatchStatusEnum {
    Cleared = 'Cleared',
    Match = 'FullMatch',
    PropertyMismatch = 'PropertyMismatch',
    PositionMismatch = 'PositionMismatch',
    VDC = 'Vdc',
    UnFound = 'Unfound',
}
export enum LayoutStateEnum {
    SiteAnalysis = 'Site Analysis',
    TRCReady = 'TRC Ready',
    FirmOrder = 'Firm Order',
    AsBuilt = 'As Built',
    Closed = 'Closed',
    AfterSalesAnalysis = 'After Sales Analysis',
    AfterSalesAsBuilt = 'After Sales As Built',
    AsBuiltIsm = 'As Built Ism',
}
export enum WppaReportTypeEnum {
    Wppa = 'wppa',
    AfterSalesWppa = 'after-sales-wppa',
}
export enum MetStationTypeEnum {
    MetMast = 0,
    RemoteSensing = 1,
    Virtual = 2,
    PPT = 3,
    SC = 4,
    TurbineLevelClimate = 5
}
export enum DirectionalSettingEnum {
    WindSectorManagement = 'WSM',
    NoiseMode = 'NM',
    NoiseMode99 = 'NM99',
    DirectionalPowerMode = 'DPM',
}
export enum ClimateTypeEnum {
    NewTimeSeries = 'NewTimeseries',
    ReuseTimeSeries = 'ReuseTimeseries',
    NewAmbient = 'NewAmbient',
    ReuseAmbient = 'ReuseAmbient',
    PadWise = 'Pad-wise',
}
